import Box from '@material-ui/core/Box';
import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { columns, getELDStatusIcon } from './config';
import { checkServiceProvider } from './serviceProviderConfig';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  list,
  changeRequest,
  i18n,
  mapRequired,
  Styled,
  driverStatusList,
  driverStatusFilteredList,
  topAction,
  history,
  filterSuccess,
  pagination,
  setPagination,
  request,
  setNumberPerPage,
  numberPerPage,
}) => {
  const [modal, setModal] = useState(false);

  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;
  const information = i18n.t('common.tableEmptyMessage');
  const isMapRequired = mapRequired === undefined || mapRequired;

  const generateRows = () => {
    const updatedList = driverStatusFilteredList.map((item) => {
      const rowItem = { ...item };
      if (checkServiceProvider('comp_generateRows_eld', SERVICE_PROVIDER, false)) {
        const operation = hasRestrictedRole([ROLES.VIEW_ONLY_FM]) ? 'view' : 'edit';
        rowItem.name = (
          <Link
            href={
              window.location.origin +
              (window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? '' : '/spireon') +
              `/user/${operation}/` +
              rowItem.driverId
            }
          >
            {rowItem.name}
          </Link>
        );
        rowItem.eld =
          window.$environment.CURRENT_LAYOUT === 'SpireonOld' ? (
            <div className={getELDStatusIcon(rowItem.eldState)} />
          ) : (
            <a
              onClick={() => {
                if (rowItem.dailyLogUrl) history.push(rowItem.dailyLogUrl.replace('.', '/spireon'));
                else setModal(true);
              }}
            >
              <div className={getELDStatusIcon(rowItem.eldState)} />
            </a>
          );
      } else {
        rowItem.name = (
          <Link href={window.location.origin + '/user/edit/' + rowItem.driverId} newPage>
            {rowItem.name}
          </Link>
        );
      }
      rowItem.lastKnownLocation =
        rowItem.unitId && checkServiceProvider('comp_generateRows_Link', SERVICE_PROVIDER, false) ? (
          <Link href={window.location.origin + '/vehicle/history?id=' + rowItem.unitId} newPage>
            {rowItem.lastKnownLocation}
          </Link>
        ) : (
          rowItem.lastKnownLocation
        );
      rowItem.unitName =
        rowItem.unitId && checkServiceProvider('comp_generateRows_Link', SERVICE_PROVIDER, false) ? (
          <Link href={window.location.origin + '/vehicle/edit/' + rowItem.unitId} newPage>
            {rowItem.unitName}
          </Link>
        ) : (
          rowItem.unitName
        );

      rowItem.currentStatus =
        rowItem.dailyLogId && checkServiceProvider('comp_generateRows_Link', SERVICE_PROVIDER, false) ? (
          <Link href={window.location.origin + '/logs/view/' + rowItem.dailyLogId} newPage>
            {rowItem.currentStatus}
          </Link>
        ) : (
          rowItem.currentStatus
        );

      rowItem.engineSpeed =
        rowItem.engineSpeed === '0.0' || rowItem.engineSpeed === '0' ? (
          checkServiceProvider('comp_generateRows_Link', SERVICE_PROVIDER, false) ? (
            <Link href={window.location.origin + '/driverStatus/history?id=' + rowItem.driverId} newPage>
              IDLE
            </Link>
          ) : (
            'IDLE'
          )
        ) : (
          rowItem.engineSpeed
        );

      return rowItem;
    });
    return updatedList;
  };

  return (
    <>
      <Modal
        open={modal}
        setOpen={() => setModal((m) => !m)}
        withCloseIcon
        alignItemsLeft
        noDataPopup
        data={{
          header: '',
          content: () => <div>No Logs available</div>,
        }}
      />
      <Styled.Wrapper>
        {topAction && window.$environment.CURRENT_LAYOUT !== 'SpireonNew' && (
          <TopActions
            {...{
              Styled,
              driverStatusList,
              changeRequest,
              filterSuccess,
              setPagination,
              request,
              i18n,
            }}
          />
        )}
        <Styled.MapWrapper>
          {isMapRequired && <GoogleMap type={'driverStatusMap'} height={'400px'} data={driverStatusList} />}
        </Styled.MapWrapper>
        <Styled.TableWrapper>
          <div className="driverstatusTitle">
            <span className="spireonOldOnly">{i18n.t('dashboard.tabs.driverStatus.heading')}</span>
            <Icon
              src={mediaUrls?.refreshIcon}
              onClick={() => changeRequest({ ...request, displayLength: numberPerPage })}
            />
            <span className="tooltiptext">{i18n.t('common.refresh')}</span>
          </div>
          <Table
            type="server"
            changeRequest={changeRequest}
            baseRequest={request}
            title=""
            data={generateRows()}
            columns={columns}
            emptyMessage={information}
            totalRecords={list?.totalElements}
            actions={[]}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
            itemsPerPage={parseInt(numberPerPage, 10)}
            outPageCountValue={setNumberPerPage}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  list: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};
